import { GetTripEtaInput, GetTripEtaResponse } from '@/models/gen/graphql';

import { GetTripEtaDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import createGraphApiHook from '@/hooks/createGraphApiHook';
import graphApi from '@/api';

type GetTripEtaGraphApiResponse = GraphApiResponse<typeof GetTripEtaDocument>;

const getTripEtaResponseSelector = (res: GetTripEtaGraphApiResponse): GetTripEtaResponse =>
  !res.errors ? ((res?.getTripEta || {}) as GetTripEtaResponse) : undefined;

const [_runGetTripEta, runRefetchGetTripEta] = graphApi(GetTripEtaDocument);

export const getTripEta = async (tripId: string): Promise<GetTripEtaResponse> => {
  const input: GetTripEtaInput = { tripId };
  const res = await runRefetchGetTripEta({ input });

  return getTripEtaResponseSelector(res);
};

export const useGetTripEta = createGraphApiHook(getTripEta, { clearDataOnError: true });

export default getTripEta;
